import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const banners = [
    {
        image: './banner0.png',
        title: 'Seu próximo carro está aqui',
        subtitle: 'Veículos selecionados com as melhores condições',
        align: 'left'
    },
    {
        image: './banner1.png',
        title: 'Qualidade e confiança',
        subtitle: 'Compra e venda com procedência garantida',
        align: 'center'
    },
    {
        image: './banner2.png',
        title: 'Financiamento facilitado',
        subtitle: 'Aprovamos seu crédito rapidamente',
        align: 'right'
    }
];


export default function BannerCarousel() {
    return (
        <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            loop
            className="w-full mt-24 md:mt-8"
        >
            {banners.map((banner, index) => (
                <SwiperSlide key={index} className="relative">
                    <img
                        src={banner.image}
                        alt={banner.title}
                        className="w-full h-[55vh] object-cover md:object-contain"
                    />

                    <div className="absolute inset-0" />

                    <div className="absolute inset-0 flex items-center">
                        <div className="container mx-auto px-6 w-full">
                            <div
                                className={`
                    max-w-xl banner-content
                    ${banner.align === 'left' && 'text-left'}
                    ${banner.align === 'center' && 'text-center mx-auto'}
                    ${banner.align === 'right' && 'text-right ml-auto'}
                `}
                            >
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

            ))}
        </Swiper>
    );
}
